const locale = {
    lang: {
        locale: 'en_US',
        now: 'Now',
        ok: 'Ok',
        timeSelect: 'select time',
        clear: 'Clear',
    },
    timePickerLocale: {
        placeholder: 'Select time',
        rangePlaceholder: ['Start time', 'End time']
    }
};
export default locale;
